import axios from 'axios'

const API_PREFIX = "/api/line"

export const apiFriendship = payload => {
    return axios.post(`${API_PREFIX}/friendship`, payload)
}

export const apiFetchGcsObject = objectPath => {
    return axios.get(`/api/gcs/public/${objectPath}`)
}

export const apiMarketStatus = () => {
    return axios.get(`/api/gold/spot/public/v1/marketstatus/now`)
}